import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadNoteTypeNotesByTrialId: INoteTypeNotesLoadByTrialIdActionCreator = (trialId) => {
        return {
            type: ACTION_NOTETYPENOTES_LOAD_BY_TRIALID,
            trialId
        }
    },
    LoadNoteTypeNotesByTrialInstitutionId: INoteTypeNotesLoadByTrialInstitutionIdActionCreator = (trialInstitutionId) => {
        return {
            type: ACTION_NOTETYPENOTES_LOAD_BY_TRIALINSTITUTIONID,
            trialInstitutionId
        }
    },
    LoadNoteTypeNotesByInstitutionId: INoteTypeNotesLoadByInstitutionIdActionCreator = (institutionId) => {
        return {
            type: ACTION_NOTETYPENOTES_LOAD_BY_INSTITUTIONID,
            institutionId
        }
    },
    LoadNoteTypeNotesByPersonnelId: INoteTypeNotesLoadByPersonnelIdActionCreator = (personnelId) => {
        return {
            type: ACTION_NOTETYPENOTES_LOAD_BY_PERSONNELID,
            personnelId
        }
    },
    LoadSuccess: INoteTypeNotesLoadSuccessActionCreator = (formData, lookups, responseStatus) => {
        return {
            type: ACTION_NOTETYPENOTES_LOAD_SUCCESS,
            formData,
            lookups,
            responseStatus
        }
    },
    LoadFailure: INoteTypeNotesLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_NOTETYPENOTES_LOAD_FAILURE,
            responseStatus
        }
    },

    Clear: INoteTypeNotesClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_NOTETYPENOTES_CLEAR,
            propertiesToClear
        }
    },

    Filter: INoteTypeNotesFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_NOTETYPENOTES_FILTER,
            formFilter
        }
    };


export const
    ACTION_NOTETYPENOTES_LOAD_BY_TRIALID = "ACTION_NOTETYPENOTES_LOAD_BY_TRIALID",
    ACTION_NOTETYPENOTES_LOAD_BY_TRIALINSTITUTIONID = "ACTION_NOTETYPENOTES_LOAD_BY_TRIALINSTITUTIONID",
    ACTION_NOTETYPENOTES_LOAD_BY_INSTITUTIONID = "ACTION_NOTETYPENOTES_LOAD_BY_INSTITUTIONID",
    ACTION_NOTETYPENOTES_LOAD_BY_PERSONNELID = "ACTION_NOTETYPENOTES_LOAD_BY_PERSONNELID",
    ACTION_NOTETYPENOTES_LOAD_SUCCESS = "ACTION_NOTETYPENOTES_LOAD_SUCCESS",
    ACTION_NOTETYPENOTES_LOAD_FAILURE = "ACTION_NOTETYPENOTES_LOAD_FAILURE",

    ACTION_NOTETYPENOTES_CLEAR = "ACTION_NOTETYPENOTES_CLEAR",

    ACTION_NOTETYPENOTES_FILTER = "ACTION_NOTETYPENOTES_FILTER";

export interface INoteTypeNotesLoadByTrialIdAction {
    type: "ACTION_NOTETYPENOTES_LOAD_BY_TRIALID";
    trialId?: number;
}

export interface INoteTypeNotesLoadByTrialIdActionCreator {
    (trialId?: number): INoteTypeNotesLoadByTrialIdAction;
}

export interface INoteTypeNotesLoadByTrialInstitutionIdAction {
    type: "ACTION_NOTETYPENOTES_LOAD_BY_TRIALINSTITUTIONID";
    trialInstitutionId?: number;
}

export interface INoteTypeNotesLoadByTrialInstitutionIdActionCreator {
    (trialInstitutionId?: number): INoteTypeNotesLoadByTrialInstitutionIdAction;
}

export interface INoteTypeNotesLoadByInstitutionIdAction {
    type: "ACTION_NOTETYPENOTES_LOAD_BY_INSTITUTIONID";
    institutionId?: number;
}

export interface INoteTypeNotesLoadByInstitutionIdActionCreator {
    (institutionId?: number): INoteTypeNotesLoadByInstitutionIdAction;
}

export interface INoteTypeNotesLoadByPersonnelIdAction {
    type: "ACTION_NOTETYPENOTES_LOAD_BY_PERSONNELID";
    personnelId?: number;
}

export interface INoteTypeNotesLoadByPersonnelIdActionCreator {
    (personnelId?: number): INoteTypeNotesLoadByPersonnelIdAction;
}

export interface INoteTypeNotesLoadSuccessAction {
    type: "ACTION_NOTETYPENOTES_LOAD_SUCCESS";
    formData: Dtos.NoteTypeNotes[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface INoteTypeNotesLoadSuccessActionCreator {
    (
        formData: Dtos.NoteTypeNotes[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): INoteTypeNotesLoadSuccessAction;
}

export interface INoteTypeNotesLoadFailureAction {
    type: "ACTION_NOTETYPENOTES_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface INoteTypeNotesLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): INoteTypeNotesLoadFailureAction;
}

export interface INoteTypeNotesClearAction {
    type: "ACTION_NOTETYPENOTES_CLEAR";
    propertiesToClear?: string[];
}

export interface INoteTypeNotesClearActionCreator {
    (propertiesToClear?: string[]): INoteTypeNotesClearAction;
}

export interface INoteTypeNotesFilterActionCreator {
    (formFilter: IFormFilter): INoteTypeNotesFilterAction;
}

export interface INoteTypeNotesFilterAction {
    type: "ACTION_NOTETYPENOTES_FILTER";
    formFilter: IFormFilter;
}

export type NoteTypeNotesActions =
    INoteTypeNotesLoadByTrialIdAction |
    INoteTypeNotesLoadByTrialInstitutionIdAction |
    INoteTypeNotesLoadByInstitutionIdAction |
    INoteTypeNotesLoadByPersonnelIdAction |
    INoteTypeNotesLoadSuccessAction |
    INoteTypeNotesLoadFailureAction |
    INoteTypeNotesClearAction |
    INoteTypeNotesFilterAction;